import { Component, Input, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';
import CodeMirror from 'codemirror';
import _ from 'underscore';
import { DomHandler } from 'primeng/dom';

import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { ButtonTypesEnum } from '../../../../Forms/enums/button-types.enum';
import { TabsStyleTypesEnum } from '../../../../Layout/enums/tabs-types.enum';
import { PlainTextService } from '../../../../PageBuilder/services/plain-text.service';
import { StatisticsResourceStatus } from '../../../enum/statistics-resource-status.enum';
import { messageSeverityEnum } from '../../../../Misc/enums/message-severity.enum';

/* eslint-disable @typescript-eslint/naming-convention */
@Component({
    selector: 'agpr-composition-report',
    templateUrl: './composition.report.component.html',
    styleUrls: ['./composition.report.component.scss'],
    standalone: false
})
export class CompositionReportComponent implements OnDestroy {
    private subscriptions: Subscription[] = [];

    readonly buttonTypes = ButtonTypesEnum;
    readonly tabsStyleTypes = TabsStyleTypesEnum;
    readonly messageSeverities = messageSeverityEnum;
    readonly statisticsResourceStatus = StatisticsResourceStatus;

    @Input() bodyPlainText: string = '';
    @Input() footerPlainText: string = '';
    @Input() set bodyHtml(bodyHtml: string) {
        this._bodyHtml = this.replaceUnsubLink(bodyHtml);
        this.bodyHtmlCode = this.replaceUnsubLink(bodyHtml);
    }
    @Input() status: StatisticsResourceStatus;
    @Input() isRSSFeed: boolean = false;

    _bodyHtml: string = '';
    selectedTabIndex = 0;


    // type string needed for ngx-codemirror
    bodyHtmlCode: string;
    cmConfig: CodeMirror.EditorConfiguration;

    constructor(
        public localizationService: LocalizationService,
        public plainTextService: PlainTextService
    ) {
        this.subscriptions.push(

        );
        this.cmConfig = {
            lineNumbers: true,
            mode: 'text/html',
            lineWrapping: true,
            readOnly: true,
            scrollbarStyle: 'null',
            viewportMargin: Infinity,
            extraKeys: {
                'Esc': this.escapeCodeMirror.bind(this, 'forward'),
                'Tab': this.escapeCodeMirror.bind(this, 'forward'),
                'Shift-Tab': this.escapeCodeMirror.bind(this, 'backward')
            }
        };
    }

    ngOnDestroy() {
        this.subscriptions.forEach(
            subscription => subscription.unsubscribe()
        );
    }

    /**
     * Replaces unsubscribe link & fixes styles
     */
    replaceUnsubLink(html: string) {
        const unsubscribeRegex = /<\s*a[^>]*>\s*[Uu]nsubscribe[^<]*<\s*\/\s*a>/;
        // @Hack: linespacing needs to be removed for titles
        return html.replace(unsubscribeRegex, '[UNSUBSCRIBE]').replace('line-height:130%;', '');
    }

    changeTab(tabIndex: number) {
        this.selectedTabIndex = tabIndex;
    }

    /**
     * Called by custom key mappings in CodeMirror config (Esc (f), Tab (f), Shift-Tab(b))
     * Focuses the next or previous focusable element depending on the direction given
     * @param direction
     */
    escapeCodeMirror = function(direction: 'forward' | 'backward') {
        const list = DomHandler.getFocusableElements(document.body);
        const activeElementIndex = list.findIndex(element => element === document.activeElement);
        if (direction === 'forward') {
            list[activeElementIndex + 1].focus();
        } else {
            list[activeElementIndex - 1].focus();
        }
    };
}
